import {EventEmitter} from "@/utils/event-emitter";
import {Project} from "@/models/base";
import {ProjectService} from "@/services";

export class ProjectEditState extends EventEmitter {
	public project: Project = new Project();
	public async fetch(){
		if(!this.project.ID){
			return;
		}
		this.project = await ProjectService.get(this.project.ID);
	}

}